import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ShoppingCart } from '../../interfaces/shopping-cart';
import { TotalComponent } from '../total/total.component';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    selector: 'app-cart',
    standalone: true,
    imports: [CommonModule, TotalComponent],
    templateUrl: './cart.component.html',
    styleUrl: './cart.component.scss',
})
export class CartComponent implements OnInit {
    @Input({ required: true }) public cart!: ShoppingCart;

    @Output() public readonly seeTotal = new EventEmitter<boolean>();

    public constructor(
        private readonly destroyRef: DestroyRef,
        private readonly cdr: ChangeDetectorRef,
    ) {
        //
    }

    public ngOnInit(): void {
        this.cart.changed.pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.cdr.markForCheck());
    }

    public open(): void {
        this.seeTotal.emit(true);
    }
}
